import React from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TasksList from '../TasksList';
import { CATEGORY } from '../TasksList/constants';


const Kanban = ({projectId}) => (
  <>
    <Grid container spacing={2}>
       <Grid item xs={12} md={6} lg={6}>
          <Paper><TasksList  projectId={projectId} category={CATEGORY.SCHEDULED}/></Paper>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
          <Paper><TasksList  projectId={projectId} category={CATEGORY.WAITING}/></Paper>
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12} md={4} lg={4}>
          <Paper>
            <TasksList projectId={projectId} category={CATEGORY.SOMEDAY} />
           </Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
          <Paper><TasksList  projectId={projectId} category={CATEGORY.NEXT}/></Paper>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
          <Paper><TasksList projectId={projectId} done={true} doneExpanded={true}/></Paper>
      </Grid>
    </Grid>
    </>

);

const mapStateToProps = state => ({
});
  
  export default connect(mapStateToProps, null )(Kanban);
  
